<style lang="less">
    .page_con.rank{
        width:100vw;
        height:100vh;
        overflow: hidden;
        background:url("../assets/images/bg3.png") no-repeat;
        background-size: 100% 100%;
        .top_con{
            width:100%;
            height:11vh;
            padding:0 5vw;
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            justify-content: space-between;
            background:url("../assets/images/topbar-longhubang.png") no-repeat;
            background-size: 100% 100%;
            img{
                width:.5rem;
                height:auto;
                display: block;
            }
        }
        .content_con{
            width:92%;
            height:89vh;
            margin:1vh auto;
            padding:3vh 2vw;
            background:#fff;
            border:.01rem solid #ddd;
            overflow-x: hidden;
            overflow-Y: auto;
            .thead{
                width:100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                text-align: center;
                .number{
                    width:28%;
                }
                .rankname{
                    width:32%;
                }
                .scoreall{
                    width:40%;
                }
                span{
                    border:.01rem solid #693905;
                    border-radius: .1rem;
                    color:#693905;
                    padding:.5vw 3vw;
                }
            }
            .list{
                width:100%;
                border:.01rem solid #ddd;
                margin-top: 2vw;
                padding:.1rem;
                background:#E7E3BD;
                border-radius: 15px;
                li{
                    width:100%;
                    height:10vh;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    text-align: center;
                    background: url("../assets/images/bg-longhubang.png") no-repeat;
                    background-size: 100% 100%;
                    margin-bottom: .05rem;
                    padding-bottom: .1rem;
                    .number{
                        width:28%;
                        text-align: left;
                        padding-left:5vw;
                        >div{
                            width:.8rem;
                            height:.8rem;
                            line-height:.8rem;
                            border-radius: 50%;
                            background:#fff;
                            color:#693905;
                            font-size: .5rem;
                            font-weight: bold;
                            text-align: center;
                        }
                    }
                    .rankname{
                        width:32%;
                        font-size: .48rem;
                        color:#693905;
                    }
                    .scoreall{
                        width:40%;
                        color:#fff;
                        font-size: .64rem;
                        // -webkit-text-stroke: 2px red;
                        text-shadow:-1px 0 #693905,
                                    0 1px #693905,
                                    2px 0 #693905,
                                    0 -1px #693905;
                    }
                }
            }
        }
    }
</style>
<template>
    <div class="page_con rank">
        <div class="top_con">
            <img src="../assets/images/closer.png" alt="" @click="$router.go(-1)">
        </div>
        <div class="content_con">
            <div class="thead">
                <div class="number"><span>名次</span></div>
                <div class="rankname"><span>名稱</span></div>
                <div class="scoreall"><span>總分</span></div>
            </div>
            <ul class="list">
                <li v-for="(item,index) in list" :key="index">
                    <div class="number">
                        <div>{{index+1}}</div>
                    </div>
                    <div class="rankname">{{item.user_name}}</div>
                    <div class="scoreall">{{item.score}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            list:[],
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData(){
            let vm = this;
            this.$http.get('/IndexDaily/rank?rest_key=1').then(res=>{
                console.log(res);
                if(res.data.code == 1){
                    vm.list = res.data.data.rank;
                }
            })
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/rank.vue